/* eslint-disable react/jsx-closing-bracket-location */
/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import Table from '../../Common/Table';
import AccountService from '../../../Service/AccountService';
import Heading from './Heading';

export default class FundingSources extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            _fundingSources: null,
            _heading: 'Loading...',
            _balance: null
        };
    }

    setFundingSourceDetais = async () => {
        const response = await AccountService.getFundingSourceByUserId(this.props.match.params.id);
        if (response.accounts && response.accounts.length !== 0) {
            this.setState({ _fundingSources: response.accounts, _balance: response.balance });
        } else {
            this.setState({ _heading: 'No funding source added with this user.' });
        }
    }

    componentDidMount() {
        this.setFundingSourceDetais();
    }

    render() {
        if (!this.state._fundingSources) {
            return this.state._heading;
        }
        const columns = [
            {
                name: 'institution_name',
                label: 'Institution Name',
                options: {
                    filter: true
                }
            },
            {
                name: 'type',
                label: 'Account Type',
                options: {
                    filter: true
                }
            },
            {
                name: 'account_mask',
                label: 'Account No',
                options: {
                    filter: true
                }
            }, {
                name: 'active',
                label: 'Deleted',
                options: {
                    filter: true,
                    customBodyRender: (value) => {
                        if (value !== undefined) {
                            return (
                                <>
                                    { value ? 'No' : 'Yes' }
                                </>
                            );
                        }
                    }
                }
            },
            {
                name: 'fs_verification_status',
                label: 'Verification Status',
                options: {
                    filter: true,
                    customBodyRender: (value) => {
                        if (value !== undefined) {
                            return (
                                <span
                                    className='badge badge-pill badge-success'
                                >{value}
                                </span>
                            );
                        }
                    }
                }
            }
        ];
        const options = {
            serverSide: false,
            print: false,
            download: false,
            filter: false,
            selectableRows: 'none'
        };
        const { _fundingSources } = this.state;
        const customer_id = _fundingSources ? _fundingSources[0].customer_id : null;

        return (
            <Table
                columns={columns}
                data={_fundingSources}
                options={options}
                title={<Heading
                    balance={this.state._balance ? this.state._balance.value : 0}
                    customer_id={customer_id}
                    reloadBalance={this.setFundingSourceDetais}
                />}
            />
        );
    }
}
